const newlineRegex = /(\r\n|\r|\n)/g;

export default function nl2br(str: string) {
  return str.split(newlineRegex).map(function (line, index) {
    if (line.match(newlineRegex)) {
      return <br key={index} />;
    }
    return line;
  });
}
